const search = {
  default: '',
  orders: '',
  catalog: '',
  customers: '',
  historic: '',
  users: ''
}
export default search
